import Swiper, {A11y, Autoplay, EffectFade, Lazy, Navigation, Pagination} from "swiper";
import initTabsAutoScroll from "./tabsAutoScroll";
import Dropdown from "./new-design/dropdowns"
import initCatalogFilter from "./new-design/catalogFilter"
import findCoordinates from "./new-design/findCoordinates"
import cutText from "./new-design/cutText"
import "./rangeSlider"
// import {toggleOptPrice} from "./opt-price";

Swiper.use([Navigation, Pagination, Lazy, EffectFade, Autoplay, A11y])

window.initUI = () => {
    new Dropdown('[data-dropdown]')
}

document.addEventListener('DOMContentLoaded', () => {

    //MAIN_SLIDER
    let mainSliderNew = new Swiper(".nm-slider", {
        // effect: "fade",
        speed: 500,
        loop: false,
        // autoplay: {
        //     delay: 5000
        // },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".nm-slider .swiper-button-next",
            prevEl: ".nm-slider .swiper-button-prev",
        },
    })

    //ADVANTAGES_SLIDER
    let advantagesSlider = new Swiper(".nm-advantages__slider", {
        slidesPerView: 1.1,
        spaceBetween: 16,
        loop: true,
        breakpoints: {
            425: {
                slidesPerView: 1.2,
                spaceBetween: 20,
            },
            720: {
                slidesPerView: 1.6,
                spaceBetween: 20,
            },
        }
    })

    //SELECTIONS_SLIDER
    let selectionsSlider = new Swiper(".nm-selections__slider", {
        slidesPerView: 1.1,
        spaceBetween: 16,
        loop: true,
    })

    //PROMOS_SLIDER
    let promosSlider = new Swiper(".nm-promos__slider", {
        slidesPerView: 1.1,
        spaceBetween: 16,
        loop: true,
    })

    //RECOMMENDATIONS_SLIDER
    let recommendationsSlider = new Swiper(".nm-recommendations__slider", {
        slidesPerView: 1.1,
        spaceBetween: 8,
        centeredSlides: true,
        speed: 500,
        loopedSlides: 3,
        loop: true,
        allowTouchMove: true,
        breakpoints: {
            425: {
                slidesPerView: 1.4,
                spaceBetween: 20,
            },
            720: {
                slidesPerView: 1.6,
                spaceBetween: 20,
            },
            1201: {
                slidesPerView: 1,
                spaceBetween: 24,
                allowTouchMove: false,
            }
        },

        on: {
            slideChangeTransitionEnd: (swiper) => {
                swiper.update()
                const prev = document.querySelector('.swiper-slide-prev .nm-recommendations__slide-content');
                const next = document.querySelector('.swiper-slide-next .nm-recommendations__slide-content');

                if (prev && next) {
                    prev.addEventListener('click', () => swiper.slidePrev());
                    next.addEventListener('click', () => swiper.slideNext());
                }

            }
        }
    })

    //PARTNERS_SLIDER
    let partnersSlider = new Swiper(".nm-partners__slider", {
        slidesPerView: 2.1,
        spaceBetween: 16,
        loop: true,
        autoplay: {
            delay: 3000
        },
        breakpoints: {
            425: {
                slidesPerView: 2.8,
                spaceBetween: 16,
            },
            720: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 24,
            }
        },
        navigation: {
            nextEl: ".nm-partners .swiper-button-next",
            prevEl: ".nm-partners .swiper-button-prev",
        },
    })

    //REVIEWS_SLIDER
    let reviewsSlider = new Swiper(".nm-reviews__slider", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: true,
        speed: 500,
        autoplay: {
            delay: 7000
        },
        breakpoints: {
            // 425: {
            //     slidesPerView: 2.8,
            //     spaceBetween: 12,
            // },
            720: {
                slidesPerView: 1,
                spaceBetween: 24,
            },
        },
        navigation: {
            nextEl: ".nm-reviews .swiper-button-next",
            prevEl: ".nm-reviews .swiper-button-prev",
        },

    })

    // similar__slider
    let similarSlider = new Swiper(".similar__slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 500,
        breakpoints: {
            600: {
                slidesPerView: 2,
            },
            900: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1250: {
                slidesPerView: 4,
            },
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: ".similar__slider .swiper-button-next",
            prevEl: ".similar__slider .swiper-button-prev",
        },

    })


    //TAPBAR
    const tapbar = document.querySelector('.nm-tapbar');
    if (tapbar) {
        if (window.screen.width <= 500) {
            tapbar.classList.add('active')
        }
    }

    //BURGER
    const burger = document.querySelector('.burger');
    const filterBtnOpen = document.querySelectorAll(".js-filter-open")
    const filter = document.querySelector(".catalog__filter")

    if (burger) {
        burger.addEventListener('click', () => {
            burger.classList.toggle('opened')
            // закрыть фильтр
            if(filterBtnOpen){
                document.body.classList.remove("filter-opened")
                filter.classList.remove("open")
            }
        })
    }

    //TABS SCROLL INTO VIEW
    initTabsAutoScroll('.nm-categories__tabs-item');
    initTabsAutoScroll('.nm-cards__tabs-btn');
    //общий класс, без стилей, только для работы TABS SCROLL
    initTabsAutoScroll('.tab-scroll');


    // Dropdown
    window.dropdown = new Dropdown('[data-dropdown]')

    // MOBILE FILTER
    initCatalogFilter()
    findCoordinates()

    //CutText
    cutText()

    window.filterRangeSliders = [];

    // rangeSlider
    initDoubleRangeSlider('#projects-range')
    initDoubleRangeSlider('#projects-range-mobile')

    // toggleOptPrice();
});


// WEBPACK FOOTER //
// ./src/js/new-main.js